import { ElemenetType } from "@/lib/constants";
import { NavLink } from "../ui";
import styles from "./DesignCategory.module.css";
import { LeadPopUpButton } from "../shared/lead/LeadPopUpButton";
type props = {
    isPopup?: boolean
    categorySlug?: string
}
export function FreeEstimateWidget({ isPopup, categorySlug }: props) {
    const getdata = (categorySlug: string) => {
        switch (categorySlug) {
            case 'modular-kitchen':
                return {
                    heading: 'Premium Kitchens',
                    subHeading: 'now from just ₹1.5 Lacs',
                    subSubHeading:'Easy EMIs from ₹3,300/month',
                    btnText: "Book Your Free Consultation"
                }
            case 'wardrobe':
                return {
                    heading: "Wardrobe Makeover",
                    subHeading:"from ₹75K",
                    subSubHeading: "Stylish storage made affordable with low-cost EMI options",
                    btnText: "Get Your Dream Wardrobe Today"
                }
            case 'false-ceiling':
                return {
                    heading: "Stunning False Ceilings",
                    subHeading:"from Rs. 84 to 158 per sq. ft.",
                    subSubHeading: "Tailored for Every Space",
                    btnText: "Book Your Free Consultation"
                } 
            case 'tv-units':
                return {
                    heading: "TV Units That Upgrade Your",
                    subHeading:"Living Room",
                    subSubHeading: "Starting from ₹8,000",
                    btnText: "Own Yours Without the Wait"
            }      
            default:
                return {
                }
        }
    }
    if (categorySlug && Object.keys(getdata(categorySlug)).length === 0) return null
    return (
        <div className={styles.desnewRtiles}>
            <div className={styles.desnewUtile}>
                <div className={styles.desInuptest}>
                    {isPopup ? <strong>{getdata(categorySlug || "").heading}</strong> : <strong>Free Estimate</strong>}
                    {isPopup ? <span>{getdata(categorySlug || "").subHeading}</span> : <span>in 30 Seconds.</span>}
                </div>
                {isPopup ? <p>{getdata(categorySlug || "").subSubHeading}</p> : <p>No calls, No wait.</p>}
            </div>
            {
                isPopup ?
                    <div className={styles.desLowertext}>
                        <LeadPopUpButton ElemenetType={ElemenetType.span} ButtonClass={styles.spantxt}>
                            {getdata(categorySlug || "").btnText}
                        </LeadPopUpButton>
                        <span style={{ fontSize: '30px' }}>&#10230;</span>
                    </div>
                    :
                    <NavLink href={process.env.SITE_URL + "/in/free-home-interior-cost-estimator"}>
                        <div className={styles.desLowertext}>
                            <span className={styles.spantxt}>Get My Estimate</span>
                            <span style={{ fontSize: '30px' }}>&#10230;</span>
                        </div>
                    </NavLink>
            }
        </div>
    )
}